export const PartnerCategoryType = {
  TransactionServices: 'Transaction Services',
  MaintenanceServices: 'Maintenance Services',
  HomeImprovementServices: 'Home Improvement',
  FinancialServices: 'Financial Services',
} as const;
